var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVehiclesActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.484,
    height: 15.995,
    viewBox: "0 0 20.484 15.995",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_Vehicles-act",
    "data-name": " Vehicles-act",
    d: "M205.473,235.229v3.838a.291.291,0,0,1-.31.31H204.2v1.27a1.919,1.919,0,1,1-3.838,0v-1.27H190.094v1.27a1.919,1.919,0,1,1-3.838,0v-1.27H185.3a.291.291,0,0,1-.31-.31v-3.838A2.216,2.216,0,0,1,187.215,233l1.326-4.2a3.022,3.022,0,0,1,2.85-2.229h7.7a3.021,3.021,0,0,1,2.85,2.229l1.326,4.2a2.173,2.173,0,0,1,1.58.649,2.315,2.315,0,0,1,.621,1.58Zm-16.2,2.116a1.6,1.6,0,1,0-2.257-2.257,1.608,1.608,0,0,0,1.129,2.737,1.651,1.651,0,0,0,1.13-.479Zm1.75-4.374h8.352a.727.727,0,0,0,.706-.9l-.677-2.681c0-.056-.056-.113-.141-.169a.376.376,0,0,0-.2-.085h-7.7a.3.3,0,0,0-.2.085.377.377,0,0,0-.141.169l-.677,2.681a.713.713,0,0,0,.677.9Zm12.36,4.374a1.608,1.608,0,1,0-2.257,0,1.582,1.582,0,0,0,1.129.48,1.707,1.707,0,0,0,1.13-.479Z",
    transform: "translate(-184.989 -226.571)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehiclesActive);
export default __webpack_public_path__ + "static/media/vehicles_active.73595182e82e750a7b894ed38fa384d4.svg";
export { ForwardRef as ReactComponent };